/**
 * класс для обьекта публичного апи
 */
window.public_api = new class {
    #request(endpoint, method, data) {
        return new Promise((resolve, reject) => {
            $.ajax(endpoint, {
                dataType: 'json',
                data: data,
                method: method,
                success: resolve,
                error: reject,
            })
        })

    }

    /**
     * Получение пунктов доставки для области на карте
     * апи возвращает не более 500 пунктов,
     * передаются координаты противоположных углов прямоугольной области
     * неважно что это за углы (верхний левый - правый нижний или нижний левый - правый верхний)
     * @param country_id страна для которой показывать пункты (чтобы при выборе тарифа в одну из стран, не показывать пвз той же службы доставик из других стран)
     * @param package_delivery_service_id служба доставки для которой надо показать пункты
     * @param lat1 широта первой первого угла области
     * @param lng1 долгота первого угла области
     * @param lat2 широта противоположного угла области
     * @param lng2 долгота противоположного угга области
     * @returns {Promise<*>}
     */
    async getPvzForGeo(country_id, package_delivery_service_id, lat1, lng1, lat2, lng2) {
        const endpoint = route('api.public.get_pvz_for_geo');
        const data = await this.#request(endpoint, 'GET', {
            country: country_id,
            package_delivery_service_id: package_delivery_service_id,
            lat1: lat1,
            lng1: lng1,
            lat2: lat2,
            lng2: lng2,
        });

        const response = data.data.map(pvz => {
            let dataJson = null;

            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = pvz.marker;
            
            // Ищем элемент с атрибутом data-pvz-json
            const pvzElement = tempDiv.querySelector('[data-pvz-json]');
            
            if (pvzElement) {
                try {
                    // Извлекаем JSON данные из атрибута
                    const jsonString = pvzElement.getAttribute('data-pvz-json');                
                    dataJson = JSON.parse(jsonString);
                } catch (error) {
                    console.error('Ошибка парсинга JSON из data-pvz-json:', error);
                }
            }

            return {
                ...pvz,
                dataJson
            }
        });

        return response;
    }
};